import React from "react";
import {IThemeBoxes} from "../../services/theme/theme-boxes.interface";
import {useServices} from "../../react-hooks/use-services.hook";

export function styledBox<TBoxName extends keyof IThemeBoxes>(boxName: TBoxName): IThemeBoxes[TBoxName] {

    const Component: React.FC<any> = (props: any) => {
        const services = useServices();
        const themeBoxes = services.theme.boxes;
        let Box: any = (themeBoxes && themeBoxes[boxName]);


        if(!Box) {
            throw new Error(`Missing styled box ${boxName}`);
        }

        return (
            <Box ref={props.forwardedRef} {...props}>
                {props.children}
            </Box>
        )

    }

    let finalComponent = React.forwardRef<any>((props, ref) => <Component {...props} forwardedRef={ref}/>);
    return (finalComponent as any) as IThemeBoxes[TBoxName];


}
